"use strict";

var prefix = 'fa-htm';
var iconName = 'angle-right';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f105'; // eslint-disable-next-line max-len

var svgPathData = 'm 595,576 q 0,-13 -10,-23 L 119,87 Q 109,77 96,77 83,77 73,87 l -50,50 q -10,10 -10,23 0,13 10,23 L 416,576 23,969 q -10,10 -10,23 0,13 10,23 l 50,50 q 10,10 23,10 13,0 23,-10 L 585,599 q 10,-10 10,-23 z';
module.exports = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData]
};